import { render, staticRenderFns } from "./UestAntrag.vue?vue&type=template&id=66b5d268&scoped=true"
import script from "./UestAntrag.vue?vue&type=script&lang=ts"
export * from "./UestAntrag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5d268",
  null
  
)

export default component.exports